import React from 'react'
import CommitteeList from './CommitteeList';
export default function CommitteeOYMList({oym, list, dropBreadcrumb,authenticated}) {
    console.log("in CommitteeOYMList");
    let objectList=list.map(committee=> oym.objectRef(committee));
    objectList.sort(oym.compareOYMObject);
    return (
       <center>
           <h1>Committees of Ohio Yearly Meeting</h1>
          <CommitteeList oym={oym} list={list} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
       </center> 
    )
}